import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService';

const TaoDonViKinhDoanhComponent = () => {
  const [formData, setFormData] = useState({
    ma_kh: '',
    ten_vt: '',
    ten_donvi: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await ManagerService.themDonViKinhDoanh(formData);
      alert('Tạo đơn vị kinh doanh thành công!');
      setFormData({ ma_kh: '', ten_vt: '', ten_donvi: '' });
    } catch (error) {
      alert('Có lỗi khi thêm đơn vị kinh doanh: ' + error.message);
    }
  };

  return (
    <Container className="my-4">
      <h3 className="mb-4">Tạo Đơn Vị Kinh Doanh Mới</h3>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Mã khách hàng</Form.Label>
          <Form.Control
            type="text"
            name="ma_kh"
            value={formData.ma_kh}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tên viết tắt</Form.Label>
          <Form.Control
            type="text"
            name="ten_vt"
            value={formData.ten_vt}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tên đơn vị</Form.Label>
          <Form.Control
            type="text"
            name="ten_donvi"
            value={formData.ten_donvi}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit">
          Thêm Đơn Vị Kinh Doanh
        </Button>
      </Form>
    </Container>
  );
};

export default TaoDonViKinhDoanhComponent;